var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      attrs: {
        id: _vm.id,
        "dialog-class": "notice-modal",
        scrollable: "",
        "hide-header": "",
        "hide-header-close": "",
        "hide-footer": "",
        "no-close-on-esc": "",
        "no-close-on-backdrop": "",
        centered: "",
      },
    },
    [
      _c(
        "section",
        { attrs: { id: "notice-modal-contents" } },
        [
          _vm.data.length > 0
            ? [
                _c(
                  "Flicking",
                  {
                    attrs: {
                      options: {
                        circular: _vm.data.length > 1 ? true : false,
                        bounce: _vm.data.length > 1 ? "20%" : 0,
                        moveType: "strict",
                      },
                      plugins: _vm.plugins,
                    },
                  },
                  [
                    _vm._l(_vm.data, function (el, i) {
                      return _c(
                        "div",
                        {
                          key: i,
                          staticClass: "notice-content",
                          class: el.category,
                        },
                        [
                          el.category !== "img"
                            ? [
                                _c("article", { attrs: { id: "headdress" } }),
                                _c(
                                  "div",
                                  {
                                    staticClass: "content-wrapper",
                                    class: el.category,
                                  },
                                  [
                                    _c("div", { staticClass: "title" }, [
                                      _vm._v(_vm._s(el.title)),
                                    ]),
                                    _vm.isPeriod(el.period)
                                      ? _c(
                                          "div",
                                          { staticClass: "modal-period" },
                                          [
                                            _vm._v(
                                              _vm._s(_vm.period(el.period))
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "div",
                                      { staticClass: "modal-content" },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            el.content
                                              .trim()
                                              .replaceAll("\\n", "\n")
                                          )
                                        ),
                                      ]
                                    ),
                                    el.img !== null
                                      ? _c(
                                          "div",
                                          { staticClass: "modal-imgs" },
                                          _vm._l(el.img, function (img, i) {
                                            return _c("img", {
                                              key: i,
                                              class: _vm.imgPosition(
                                                i,
                                                el.img.length
                                              ),
                                              attrs: { src: img },
                                            })
                                          }),
                                          0
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                el.buttonText !== null
                                  ? _c(
                                      "div",
                                      { staticClass: "modal-link-wrapper" },
                                      [
                                        _c(
                                          "button",
                                          {
                                            staticClass: "modal-link",
                                            on: {
                                              click: function ($event) {
                                                return _vm.openURL(
                                                  el.isExternalUrl,
                                                  el.url
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(el.buttonText) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            : _c("img", {
                                staticClass: "cursor-pointer w-100",
                                attrs: { src: `${el.img}` },
                                on: {
                                  click: function ($event) {
                                    return _vm.openURL(el.isExternalUrl, el.url)
                                  },
                                },
                              }),
                        ],
                        2
                      )
                    }),
                    _c("div", {
                      staticClass: "flicking-pagination",
                      attrs: { slot: "viewport" },
                      slot: "viewport",
                    }),
                  ],
                  2
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("section", { staticClass: "btn-wrapper" }, [
        _vm.noMore
          ? _c("label", { staticClass: "modal-btn" }, [
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: _vm.noMoreCheck,
                    expression: "noMoreCheck",
                  },
                ],
                attrs: { type: "checkbox" },
                domProps: {
                  checked: Array.isArray(_vm.noMoreCheck)
                    ? _vm._i(_vm.noMoreCheck, null) > -1
                    : _vm.noMoreCheck,
                },
                on: {
                  change: function ($event) {
                    var $$a = _vm.noMoreCheck,
                      $$el = $event.target,
                      $$c = $$el.checked ? true : false
                    if (Array.isArray($$a)) {
                      var $$v = null,
                        $$i = _vm._i($$a, $$v)
                      if ($$el.checked) {
                        $$i < 0 && (_vm.noMoreCheck = $$a.concat([$$v]))
                      } else {
                        $$i > -1 &&
                          (_vm.noMoreCheck = $$a
                            .slice(0, $$i)
                            .concat($$a.slice($$i + 1)))
                      }
                    } else {
                      _vm.noMoreCheck = $$c
                    }
                  },
                },
              }),
              _c("article", { staticClass: "btn-content" }, [
                _c("span"),
                _vm._v(
                  "\n        " +
                    _vm._s(_vm.$t("modal.notice.week")) +
                    "\n      "
                ),
              ]),
            ])
          : _c("div", { staticClass: "w-100" }),
        _c("button", { staticClass: "modal-btn", on: { click: _vm.close } }, [
          _c("article", { staticClass: "btn-content" }, [
            _c(
              "svg",
              {
                attrs: {
                  xmlns: "http://www.w3.org/2000/svg",
                  width: "17",
                  height: "16",
                  viewBox: "0 0 17 16",
                  fill: "none",
                },
              },
              [
                _c("path", {
                  attrs: {
                    d: "M4.5 4L12.5001 12.0001",
                    stroke: "#666666",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
                _c("path", {
                  attrs: {
                    d: "M12.5 4L4.49993 12.0001",
                    stroke: "#666666",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                  },
                }),
              ]
            ),
            _vm._v("\n        " + _vm._s(_vm.$t("modal.close")) + "\n      "),
          ]),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }